/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import SupportButtonHeader from "./common/SupportButtonHeader";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

import { useAuth } from "../context/AuthContext";
import { useHistory } from "react-router-dom";

import {
 
  LogoOriginal

} from "../_components/Imagepath";



import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
import { t } from "i18next";
const Login = (props) => {


  const { t } = useTranslation();
  const { user, login, credLoading } = useAuth();
  const history = useHistory();
  const recaptcha = useRef();
  
  // Add state for expandable descriptions
  const [expandedInfo, setExpandedInfo] = useState({ vendor: false, agency: false });

const schema = yup.object({
  email: yup
    .string()
    .matches(emailrgx, t("Email is required"))
    .required(t("Email is required"))
    .trim(),
  password: yup.string().required(t("Password is required")).trim(),
});


  useEffect(() => {
    
    if (user?.token) {

      history.push('/dashboard')
    }
  }, [user]);
  const [eye, seteye] = useState(true);
  const inputValues = {
    email: "",
    password: "",
  };

  const {
    reset,
    handleSubmit,
    control,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: inputValues,
  });
  useEffect(() => {
    reset(inputValues);
  }, [reset]);

  const onSubmit = async (data) => {
    const reacapchaValue = recaptcha.current.getValue();
    if (!reacapchaValue) {
      setError("root", {
        type: "server",
        message: "Please verify that you are not a robot"
      });
      return;
    }
    data.recaptcha_token = reacapchaValue;
    clearErrors();
    login(data, (error) => {
      console.log("error", error);
      if (!error) {
        history.push("/dashboard"); // Check if its working with useHistory
      } else {
      
        recaptcha.current.reset();
        
        if (error.response?.data?.non_field_errors?.[0] == 'Not Verified') {
          console.log('unverified');
          history.push("/verification-notifications");
        }
        setError("root", {
          type: "server",
          message: error.response?.data?.non_field_errors?.[0] || "Login failed"
        });
      }
    });
  };

  const onEyeClick = () => {
    seteye(!eye);
  };

  // Add function to toggle info descriptions
  const toggleInfo = (type) => {
    setExpandedInfo(prev => ({
      ...prev,
      [type]: !prev[type]
    }));
  };


  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={LogoOriginal}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>{t("Login")}</h1>
                  <p className="account-subtitle">{t("Access to our dashboard")}</p>
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-block mb-3 input_text">
                        <label className="form-control-label">
                          {t("Email")}
                        </label>
                        <Controller
                          name="email"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <input
                              className={`form-control  ${errors?.email ? "error-input" : ""
                                }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                          
                            />
                          )}
                        />

                        <small>{errors?.email?.message}</small>
                      </div>
                      <div className="input-block mb-3 input_text login-eye">
                        <label className="form-control-label">{t("Password")}</label>
                        <Controller
                          name="password"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="pass-group">
                              <input
                                type={eye ? "password" : "text"}
                                className={`form-control  ${errors?.password ? "error-input" : ""
                                  }`}
                                value={value}
                                onChange={onChange}
                                autoComplete="false"
                                
                              />
                              <span
                                onClick={onEyeClick}
                                className={`fas toggle-password ${eye ? "fa-eye-slash" : "fa-eye"
                                  }`}
                              />
                            </div>
                          )}
                        />

                        <small>{errors?.password?.message}</small>
                      </div>
                      <div className="input-block mb-3">
                        <div className="row">
                          <div className="col-6">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                checked
                                readOnly
                                className="form-check-input"
                                id="cb1"
                              />
                              <label
                                className="custom-control-label ms-1"
                                htmlFor="cb1"
                              >
                                {t("Remember me")}
                              </label>
                            </div>
                          </div>
                          <div className="col-6 text-end">
                            <Link className="forgot-link" to="/forgot-password">
                              {" "}
                              {t("Forgot Password ?")}{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_SITE_KEY}
                        ref={recaptcha}
                        className="mb-2"
                      />
                      <button
                        className="btn btn-lg btn-block w-100 btn-primary w-100"
                        type="submit"
                      >
                        {t("Login")}
                        {credLoading && <i className="fa-solid fa-spinner fa-spin" style={{ margin: "0 10px" }}></i>}
                      </button>
                      <small style={{ color: "red" }}> {errors.root && <p>{errors.root.message}</p>}</small>
                    </form>
                    <div className="login-or">
                      <span className="or-line" />
                      <span className="span-or">{t("OR")}</span>
                    </div>

                    <div className="text-center dont-have">
                     {t("Don't have an account yet?")}{" "}
                      <ul>
                        <li> 
                          <Link to="/register-vendor">{t("Register as Vendor")}</Link>
                          <span 
                            onClick={() => toggleInfo('vendor')} 
                            style={{ cursor: 'pointer', marginLeft: '5px', color: '#007bff' }}
                            title="Click for more info"
                          >
                            ℹ️
                          </span>
                          {expandedInfo.vendor && (
                            <div style={{ 
                              fontSize: '12px', 
                              color: '#666', 
                              marginTop: '5px', 
                              padding: '8px', 
                              backgroundColor: '#f8f9fa', 
                              borderRadius: '4px',
                              border: '1px solid #e9ecef'
                            }}>
                              {t("Vendors submit biodata to agencies and end employers")}
                            </div>
                          )}
                        </li>
                        <li> 
                          <Link to="/register-agency">{t("Register as Agency")}</Link>
                          <span 
                            onClick={() => toggleInfo('agency')} 
                            style={{ cursor: 'pointer', marginLeft: '5px', color: '#007bff' }}
                            title="Click for more info"
                          >
                            ℹ️
                          </span>
                          {expandedInfo.agency && (
                            <div style={{ 
                              fontSize: '12px', 
                              color: '#666', 
                              marginTop: '5px', 
                              padding: '8px', 
                              backgroundColor: '#f8f9fa', 
                              borderRadius: '4px',
                              border: '1px solid #e9ecef'
                            }}>
                              {t("Agencies connect vendors biodata with employers and manage business relationships")}
                            </div>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

             <div className="lang-menu">
                <ul className="nav nav-tabs user-menu">
                 <SupportButtonHeader/>
                  <div className="lang-item ">
      <Lang />
      </div>
   
                        
                </ul>

              </div>



          </div>
 </div>
        </div>
      </>
      );
};
      export default Login;
